export default __webpack_public_path__ + "static/media/banner-xpert1.80709cd8.png";